function normalize(value) {
  return String(value || "").trim().toLowerCase();
}

export function isApprovalPending(item) {
  return normalize(item?.approval_status || "not_requested") === "pending";
}

export function isApprovalPendingReview(item) {
  return normalize(item?.approval_status || "not_requested") === "pending_review";
}

export function isApprovalApproved(item) {
  return normalize(item?.approval_status || "not_requested") === "approved";
}

export function canRequestApprovalForItem(item, canRequest, completionStatuses) {
  if (!canRequest) return false;

  const completionSet = new Set((completionStatuses || []).map((s) => normalize(s)));
  const status = normalize(item?.status);
  const evidence = String(item?.evidence || "").trim();
  const approvalStatus = normalize(item?.approval_status || "not_requested");

  return completionSet.has(status)
    && Boolean(evidence)
    && (approvalStatus === "not_requested" || approvalStatus === "rejected");
}

export async function requestBulkEmsApproval(requestFn, moduleKey, items, notes = "") {
  let ok = 0;
  let failed = 0;

  for (const it of items || []) {
    try {
      await requestFn({
        module_key: moduleKey,
        item_id: it.id,
        notes,
      });
      ok += 1;
    } catch {
      failed += 1;
    }
  }

  return { ok, failed };
}
